export default __webpack_public_path__ + "static/media/Helm of Vicious Frenzy.87203aec.jpg";